import React from 'react';
import { useTranslation } from 'next-i18next';
import { useStartBook } from 'src/hooks/useStartBook';
import { EmptyStateButton } from '../EmptyStateButton/EmptyStateButton';
export const Book = ({
  onClick,
  label,
  className,
  disabled,
  style,
  dataTestId
}) => {
  const {
    t
  } = useTranslation();
  const startBook = useStartBook();
  if (!startBook) return null;
  return /*#__PURE__*/React.createElement(EmptyStateButton, {
    "data-testid": dataTestId,
    style: style,
    className: className,
    onClick: onClick || startBook,
    disabled: disabled
  }, label || t('b2c.buttons.bookNewAppointment'));
};